import React from "react";
import Field from "../simple/field";
import {getSchemeRefsValues} from "@helpers/functions";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    alignRight: {
        textAlign: 'right',
    },
}));

export const IdentityDocumentForm = ({schemeIdentityDocument, identityDocument, onSave = f => f}) => {
    const classes = useStyles();
    const { t } = useTranslation();
    let refs = {};
    const save = () => {
        const data = getSchemeRefsValues(schemeIdentityDocument.struct, refs);
        data.id = Number(refs['doc_id'].value);
        onSave(data);
    };
    return (
        <React.Fragment>
            <input ref={input => refs['doc_id'] = input} type="hidden" defaultValue={identityDocument.doc_id} />
            <Grid container spacing={2}>
                {Object.keys(schemeIdentityDocument.struct).map((fieldName, numFieldScheme) => {
                    return(
                        <Grid item xs={12} key={numFieldScheme}>
                            <Field
                                name={fieldName}
                                scheme={schemeIdentityDocument.struct[fieldName]}
                                defaultValue={identityDocument[fieldName]}
                                refs={refs} />
                        </Grid>
                    )
                })}
                <Grid item xs={12} className={classes.alignRight}>
                    <Button variant="contained" color="primary" onClick={save}>
                        {t('save')}
                    </Button>
                </Grid>
            </Grid>
        </React.Fragment>
    );
};
export default IdentityDocumentForm;